export default "__VITE_ASSET__CJB9rplo__"